import { X } from "@phosphor-icons/react";

// VAGUE 42 — qualification fine : motif de refus ou offre visée par un prospect intéressé.
export const REFUSAL_OPTIONS = [
  { id: "price", label: "Prix trop élevé" },
  { id: "no_need", label: "Aucun besoin" },
  { id: "already_equipped", label: "Déjà équipé" },
  { id: "bad_experience", label: "Mauvaise expérience commerciale" },
  { id: "other", label: "Autre motif" },
];
const INTEREST_OPTIONS = [
  { id: "premium", label: "Abonnement Premium" },
  { id: "premium_ia", label: "Premium IA" },
  { id: null, label: "Pas encore précisé" },
];
export const QUALIFY_STATUSES = new Set(["refused", "refused_final", "interested"]);

export default function QualifyStatusModal({ status, bizName, bizId, onPick, onClose }) {
  const isRefusal = status !== "interested";
  const btn = "w-full text-left px-3 py-2.5 rounded-sm border text-sm font-medium transition-colors";
  return (
    <div className="fixed inset-0 z-[90] bg-foreground/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-3"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }} data-testid={`qualify-modal-${bizId}`}>
      <div className="bg-card border border-border rounded-sm shadow-xl w-full max-w-sm p-4">
        <div className="flex items-start justify-between gap-2 mb-3">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-widest font-bold text-muted-foreground">
              {isRefusal ? "Motif du refus" : "Le prospect est intéressé par"}
            </div>
            <div className="font-display font-semibold text-sm truncate">{bizName}</div>
          </div>
          <button type="button" onClick={onClose} className="p-1 text-muted-foreground hover:text-foreground" aria-label="Fermer" data-testid="qualify-close">
            <X size={16}/>
          </button>
        </div>
        <div className="space-y-1.5">
          {isRefusal ? (
            <>
              {REFUSAL_OPTIONS.map((o) => (
                <button key={o.id} type="button" onClick={() => onPick({ status, refusal_reason: o.id })}
                  className={`${btn} border-border hover:border-secondary hover:bg-secondary/5`} data-testid={`qualify-refusal-${o.id}`}>
                  {o.label}
                </button>
              ))}
              <button type="button" onClick={() => onPick({ status: "refused_final", refusal_reason: "no_more_contact" })}
                className={`${btn} border-red-300 bg-red-50 text-red-800 hover:bg-red-100`} data-testid="qualify-refusal-no_more_contact">
                Ne souhaite pas être rappelé
                <span className="block text-[11px] font-normal text-red-700/80">Exclu de toutes les futures listes (opposition RGPD)</span>
              </button>
            </>
          ) : (
            INTEREST_OPTIONS.map((o) => (
              <button key={o.label} type="button" onClick={() => onPick(o.id ? { status, hot_lead_offer: o.id } : { status })}
                className={`${btn} border-border hover:border-primary hover:bg-primary/5`} data-testid={`qualify-interest-${o.id || "none"}`}>
                {o.label}
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
